import { gql } from '@apollo/client';

/**
 * 修改 Invoice 的 Due Date
 */
export const UPDATE_INVOICE_DUE_DATE = gql`
  mutation UpdateInvoiceDueDate($invoiceId: ID!, $newDueDate: Int!) {
    updateInvoiceDueDate(invoiceId: $invoiceId, newDueDate: $newDueDate) {
      success
      code
      message
      invoiceId
      invoiceNo
    }
  }
`;

/**
 * Invoice 重开（重新聚合费用生成新实例）
 */
export const REISSUE_INVOICE = gql`
  mutation ReissueInvoice($billId: ID!) {
    reissueInvoice(billId: $billId) {
      success
      code
      message
      invoiceId
      invoiceNo
    }
  }
`;

/**
 * Invoice 邮件推送到所选客户邮箱
 */
export const SEND_INVOICE_EMAIL = gql`
  mutation SendInvoiceEmail($invoiceId: ID!, $recipients: [SendInvoiceRecipientInput!]!) {
    sendInvoiceEmail(invoiceId: $invoiceId, recipients: $recipients) {
      success
      code
      message
    }
  }
`;
